//import axios from "axios";
import Swal from "sweetalert2";
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
export default {
  //
  data() {
    return {
      // this component Id: user dashboard, admin dashboard etc...
      componentId: 2,
      gUserId: 0,
      gUserName: "",
        //SERVER: 'https://localhost:44301',//please woerk y dont you work //
        SERVER: 'https://practiceapis.veinspracticesolution.com',//////
        //SERVER: 'https://dev-practiceapis.veinspracticesolution.com',
         
        //PRACTICESERVER: 'https://practice.veinspracticesolution.com',
        PRACTICESERVER: 'https://practice.veinspracticesolution.com',
        //USERSSERVER:'http://localhost:8080',
      
        USERSSERVER: 'https://user.veinspracticesolution.com',
        //USERSSERVER: 'https://dev-user.veinspracticesolution.com',
        //CHECKINSERVER: 'http://localhost:8081',       
    
        //CHECKINSERVER: 'https://checkin.veinspracticesolution.com/',
        CHECKINSERVER: 'https://checkin.veinspracticesolution.com/',
       
        //SERVER: 'https://prod-practiceapis.veinspracticesolution.com/',
      UKEY: "<VEINS2021/>",
      mUserRoles: [],
      accessObj: null,
      LogoutTime: 4.32e+7,// 12hr //3.6e+6, //1 hr,//1.8e+6,//30mins
      TimerObject1: {},
  
      dummyComm: {
        auditFlag: 0,
        auditFlagVal: "NULL",
        visitTypeId: 0,
        visitReasonId: 0,
        extras: "",
        visitId: 0,
        patientId: 0,
        stageId: 0,
        NextStageId: 0,
        stepId: 0,
        questId: 0,
        myDate: "",
        myTime: "",
        pure: "",
        filter: "",
        pageSize: 10,
        pageNumber: 0,
        Filter: "",
      },    
      roleCheck: [
        {
          UserId: "",
          RoleMapperId: "",
          RoleId: "",
          ComponentId: "",
          OptionId: "",
          CanCreate: "",
          CanRead: "",
          CanDelete: "",
          CanUpdate: "",
          DownloadCsv: "",
          IsActive: 0,
        },
      ],
      candoUrls: "",
    };
  },

  methods: {
    gFillUserInfo(operators) {
      const str = localStorage.OSversion;
      const arr = str.split(this.UKEY);
      this.gUserId = arr[0] * 1;

      const xx = operators.find((f) => f.operatorId == this.gUserId);
      this.gUserName = xx.operatorName;
    },
    convertUTCDateToLocalDate(date) {
      var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      newDate.setHours(hours - offset);
      newDate = newDate.getTime();
      return newDate;
    },

    intDummyComm() {
      var str = "";
      if (
        localStorage.OSversion == undefined ||
        localStorage.OSversion === "null"
      ) {
        str = window.location.search.slice(7);
        localStorage.xeon = str.slice(-1);
        str = str.slice(0, -7);
        let xyz = str.split("%3CVEINS2021/%3E");
        let abc = "";
        for (let i = 0; i < xyz.length; i++) {
          abc += xyz[i];
          if (i < xyz.length - 1) {
            abc += "<VEINS2021/>";
          }
        }
        localStorage.OSversion = abc;
      }
      this.dummyComm.auditFlagVal = localStorage.OSversion;
      this.dummyComm.prId = localStorage.xeon;
      this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
    },

    mixinMakeCommString() {
      let x = "";
      for (var i = 0; i < arguments.length; i++) {
        x += arguments[i] + this.UKEY;
      }
      return x;
    },

    
    warningToast(e) {
        createToast(e,
         {
           type: 'danger',
           showIcon: 'true',
           transition: 'slide',
           timeout: 1500
         });
       },

    //-- Toast -- PrimeVue
    showErrorToast(msg, interval = 4000) {
      this.$toast.add({
        severity: "error",
        summary: "Error Message",
        detail: msg,
        life: interval,
      });
    },

    showSuccessToast(msg, interval = 3000) {
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: msg,
        life: interval,
      });
    },

    //Toast Messages
    successToastUpd() {
      createToast("Information Updated", {
        type: "success",
        showIcon: "true",
        transition: "slide",
        timeout: 1500,
      });
    },

    successToast() {
      createToast("Information Added", {
        type: "success",
        showIcon: "true",
        transition: "slide",
        timeout: 1500,
      });
    },

    
    errorToast(e) {
      createToast(e, {
        type: "danger",
        showIcon: "true",
        transition: "slide",
        timeout: 1500,
      });
    },

    errorToastUpd(e) {
      createToast(e, {
        type: "danger",
        showIcon: "true",
        transition: "slide",
        timeout: 1500,
      });
    },

    ShowError(msg) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
      });
    },

    ShowConfirmation(msg) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
      });
    },

    ShowWarning(msg) {
      Swal.fire({
        title: "Warning",
        text: msg,
      });
    },

    ShowSuccess(msg) {
      Swal.fire({
        icon: "success",
        title: "success",
        text: msg,
      });
    },

    ShowErrorAutoClose(msg) {
      let timerInterval;
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg,
        timer: 2000,
        didOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(2000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
    },

    ShowSuccessAutoClose(msg) {
      let timerInterval;
      Swal.fire({
        icon: "success",
        title: "success",
        text: msg,
        timer: 2000,
        didOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(2000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
    },

    ShowSuccessAutoClose_10(msg) {
      let timerInterval;
      Swal.fire({
        icon: "success",
        title: "successfully added",
        text: msg,
        timer: 6000,
        didOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(2000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
    },
    isValidDateTrue(myDate)
    {
      var timeStamp = Date.parse(myDate);
      if(isNaN(timeStamp)==false){
         return true;
      }
      else{
        return false;
      }
    },

    isValidateDate(dateStr) {
        var val = dateStr.split("-");
         var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
         var day = currentDate.getDate()
         var month = currentDate.getMonth() + 1
         var year = currentDate.getFullYear()
         if(dateStr.substring(0, 4) >= 1900){
         console.log("<b>" + day + "/" + month + "/" + year + "</b>")
         console.log(val);
           if(year == val[0]) {
             if(month.toString() > val[1]){ 
           var re = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
           return re.test(dateStr);
            } else if(month.toString() == val[1]){
               if(day.toString() > val[2]){
                var re1 = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
                return re1.test(dateStr); 
               } else{ return; } }
            else { return;}
           } 
           else if(year > val[0]){
            var re_1 = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
            return re_1.test(dateStr);
          } else if(year < val[0]){
            return;
          }
        } else{ return;}
    },

    getAge(dateString) {
      var now = new Date();
      var today = new Date(now.getYear(),now.getMonth(),now.getDate());
    
      var yearNow = now.getYear();
      var monthNow = now.getMonth();
      var dateNow = now.getDate();
    
      var dob = new Date(dateString.substring(6,10),
                         dateString.substring(0,2)-1,                   
                         dateString.substring(3,5)                  
                         );
    
      var yearDob = dob.getYear();
      var monthDob = dob.getMonth();
      var dateDob = dob.getDate();
      var age = {};
      var ageString = "";
      var yearString = "";
      var monthString = "";
      var dayString = "";
    
    
      var yearAge = yearNow - yearDob;
    
      if (monthNow >= monthDob)
        var monthAge = monthNow - monthDob;
      else {
        yearAge--;
        monthAge = 12 + monthNow -monthDob;
      }
    
      if (dateNow >= dateDob)
        var dateAge = dateNow - dateDob;
      else {
        monthAge--;
        dateAge = 31 + dateNow - dateDob;
    
        if (monthAge < 0) {
          monthAge = 11;
          yearAge--;
        }
      }
    
      age = {
          years: yearAge,
          months: monthAge,
          days: dateAge
          };

    return age;  
    },

    dateAdd(date, interval, units) {
    
      if (!(date instanceof Date)) return undefined;
      var ret = new Date(date);
      var checkRollover = function() {
        if (ret.getDate() != date.getDate()) ret.setDate(0);
      };
      switch (String(interval)) {
        case "y":
          ret.setFullYear(ret.getFullYear() + units);
          checkRollover();
          break;
        case "q":
          ret.setMonth(ret.getMonth() + 3 * units);
          checkRollover();
          break;
        case "M":
          ret.setMonth(ret.getMonth() + units);
          checkRollover();
          break;
        case "w":
          ret.setDate(ret.getDate() + 7 * units);
          break;
        case "d":
          ret.setDate(ret.getDate() + units);
          break;
        case "h":
          ret.setTime(ret.getTime() + units * 3600000);
          break;
        case "m":
          ret.setTime(ret.getTime() + units * 60000);
          break;
        case "s":
          ret.setTime(ret.getTime() + units * 1000);
          break;
        default:
          ret = undefined;
          break;
      }
      return ret;
    },

    dateToLocalString(date) {
      date = new Date(date);
      //console.log("Date: ",date);
      let dstr = date.toLocaleDateString();
      dstr += " " + date.toLocaleTimeString();
      return dstr;
    },
    dateToSqlServerDateFormat(date) {
      date = new Date(date);
      var dstr =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      dstr += " " + date.toLocaleTimeString();
      return dstr;
    },

    dateToYMD(date) {
      date = new Date(date);
      var dstr =
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2);
      return dstr;
    },

    dateToMDY(date) {
     
      date = new Date(date);
      var dstr =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        "/" +
        date.getFullYear();
      return dstr;
    },

    dateToMDY_1(date) {
   
      date = new Date(date);
      var dstr =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()) +
        "/" +
        date.getFullYear();
      return dstr;
    },

    dateToMDY_Dashed(date) {
      date = new Date(date);
      var dstr =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2) +
        "-" +
        date.getFullYear();
      return dstr;
    },

    dateToMDY_Slash(date) {
     
      //date = new Date(date);
      var dstr =
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        "/" +
        date.getFullYear();
      return dstr;
    },

    dateToYM(date) {
      date = new Date(date);
      var dstr =
        date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2);
      return dstr;
    },

    validEmail(email) {
      if (email == "") {
        return true;
      }
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    Validity(e) {
      this.ShowWarning("Valid email required");
      e.preventDefault();
    },

    isEmpty(str) {
      if (typeof str === "undefined") return false;
      if (str === null) return false;
      if (str.length < 1) return false;
      if (str === "") return false;
      return true;
    },

    //Autologout
    AutoLogout() {
      console.log("Logout");
      this.logoutClick_1();
      localStorage.icore = "";
      localStorage.BeToken = '';
      location.href = this.USERSSERVER;
      return;
    },

    logoutClick_1() {
      this.intDummyComm();
      const url = this.SERVER + `/VNSPRAAPI/Practices/Logout`;
      axios({
        method: "post",
        url: url,
        data: this.dummyComm,
      }).then(() => {});

      localStorage.icore = "";
      location.href = this.USERSSERVER;
      console.log("you are logout due to inactivity");
    },

    ResetLogoutTimeGlob() {
      clearTimeout(this.TimerObject1);
      this.TimerObject1 = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },

    async mixinsAxiosGetData(myUrl, myData) {
      let data = "err";
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
      })
        .then((res) => {
          if (res) data = res.data;
          else data = "error";
        })
        .catch(function(err) {
          console.log(err);
        })
        .finally(() => {
          this.ResetLogoutTimeGlob();
        });

      return data;
    },

    async mixinsAxiosGetDataText(myUrl, myData) {
      let data = "err";
      await axios({
        method: "post",
        url: myUrl,
        data: myData,
        contentType: "application/json",
        dataType: "json",
      })
        .then((res) => {
         //debugger
          data = res.data;
        })
        .catch(function(err) {
          console.log(err);
        })
        .finally(() => {
          this.ResetLogoutTimeGlob();
        });

      return data;
    }, // axiosGetData
  }, // end methods
};
